import { useAuthStore } from '@/stores/authStore'

// currentOrgId and orgName are derived from the authenticated session.
// orgName is populated after the first successful GET /organizations/:orgId call.
export function useOrgStore() {
  const orgId = useAuthStore((s) => s.orgId)
  const orgName = useAuthStore((s) => s.orgName)
  return {
    currentOrgId: orgId ?? '',
    orgName: orgName ?? orgId ?? '',
  }
}
